
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../../services/timesheetreportsService';
import {timesheetService} from '../../services/timesheetService';
import {timesheetuserService} from '../../services/timesheetUserservice';
import {formatterhelper} from '../../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch } from "react-icons/fa";
import Smallloader from '../../compnents/loader';
import {adminService} from '../../services/adminService';
import { Toast } from 'primereact/toast';

const Addrds = ({tabname}) => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        rdsfile: '',
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [rdsdatacomp,setrdsDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [subtaskscomp,settaskscomp] = useState([]);
    const [subclientLoader,setSubclientloader] = useState(<></>);
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [addtimesheettoggle,settoggle] = useState(false); 
    const [editobj,seteditobj] = useState(null);
    const [errors, setErrors] = useState({});
    const [base64File, setBase64File] = useState('');
    const [selectedmonth,setMonth] = useState({"month":''});
     
    const [formData2, setForm2Data] = useState({
        selectedclient: '',
        selectedsubclient: '',
        task:'',
        minutes:'',
        billedminutes:'',
        budgethours:'',
        remainingbudgethours:'',
        count:'',
        fillingfor:'',
        remarks:''
      });
     
    useEffect(()=>{
      _getteam();
    },[]);

    const handleChange = (e) => {
        const file =  e.target.files[0];
        // console.log("handle change");
        // console.log(file);

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                // `result` contains the Base64-encoded string
                let base64 = reader.result.split(',')[1];
                setBase64File(base64);
                // setBase64File(reader.result.split(',')[1]); // Remove the data URL prefix
              };
              reader.readAsDataURL(file);
        }
     };

    const handleSubmit = (e) => {
        e.preventDefault();
        let obj = {
           'file': base64File,
        }
        setloading(false);
        timesheetService.updateRds(obj).then((response)=>{
            // console.log(response);
            // console.log("response data");
            if(response.status == 200){
                 setloading(true);
                 toast.current.show({severity:'success', summary: "Rds", detail:`Rds updated successfully!`, life: 3000}); 
            }else{
                 setloading(true);
                 toast.current.show({severity:'error', summary: "Rds", detail:`Rds Not updated`, life: 3000}); 
            }
        }).catch((error)=>{
            // console.log(error); 
            // console.log("error data");
            setloading(true);
            toast.current.show({severity:'error', summary: "Rds", detail:`Error`, life: 3000}); 
        });
        // addteam({team:formData});
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = {};
  
        if (formData.team_name == '') {
          newErrors.team_name = 'Team name is required';
          valid = false;
        }

        setErrors(newErrors);

       return valid; 
    }

    function addteam({team}){

        if(!validateForm()){
            return;
        }

        adminService.addteam({team:team}).then((response)=>{
        //    console.log('response'); 
        //    console.log(response); 
           if(response.status == 200){
            toast.current.show({severity:'success', summary: "Teams", detail:`Teams updated successfully!`, life: 3000});
           }else{
            toast.current.show({severity:'error', summary: "Teams", detail:`Not updated successfully!`, life: 3000}); 
           }
           _getteam();
        //    setFormData({rolename:''});
        }).catch((error)=>{
            toast.current.show({severity:'error', summary: "Teams", detail:`Not updated successfully!`, life: 3000}); 
        });
    } 


    function _getteam(){
        let emparr = [];
        setloading(false);

        adminService.getteam().then((response)=>{
           console.log('response'); 
        //    console.log(response.data.data); 
           response.data.data.forEach((value,index)=>{
             console.log(value.name);
             emparr.push(<tr><td>{value.id}</td><td style={{textAlign:'left'}}>{value.team_name}</td></tr>);
           });
           
           setDatacomp(emparr);
           setloading(true);
           setDatastate(true);
        //    const [datacomp,setDatacomp] = useState([]); 
        }).catch((error)=>{
            setloading(true);
            setDatastate(true);
        });
    } 

   const updateRds = (e) =>{
      e.preventDefault();
      console.log("update Rds files");
      console.log(selectedmonth);
       
   } 


   return (
        <>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding-two'><h6>{tabname}</h6></div>
            <Toast ref={toast} />
            <div className='card card-custom-style card-style-padding'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className="col-md-4">
                        <label className='pull-left'>Select Rds Excel <span className='error'>(Use CSV file)</span></label>
                        <br/>
                        <input type='file' name='file' accept=".csv" required onChange={(e)=>handleChange(e)} className='form-control'/>
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Submit" severity="success" rounded className='custom-btn-style'>{!isloaded ? loader.Smallloader() : <></>}</Button>
                        </div>
                    </div>
                </div>
                </form>

                <br/><br/>
               <form onSubmit={(e) => {updateRds(e)}}>   
                <div className='row'>
                    <div className="col-md-4">
                        <label className='pull-left'>Update Month Wise Rds Excel<span className='error'></span></label>
                        <br/>
                        <input type='month' name='month' onChange={(e)=>{setMonth(e.target.value)}}  required className='form-control'/>
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Update" severity="success" rounded className='custom-btn-style'>{!isloaded ? loader.Smallloader() : <></>}</Button>
                        </div>
                    </div>
                </div>
                </form>
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <div className='row'>
                    <div className='col-md-6'></div>
                    <div className='pagination col-md-6'>
                        {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
                    </div>
                </div>
               
               
                {/* <div className='row'>
                    <div className='col-md-12'>
                    {!isloaded ? loader.Loadermd() : dataavail ?
                    (<table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col" style={{textAlign:'left'}}>Team Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {datacomp}
                        </tbody>
                    </table>) : (<p>No data Found</p>)} 
                    </div>
                   
                </div> */}
                <br/> 
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default Addrds;

